import { CategoryContract } from '../../categories/domain/contracts/category_contract';
import { categoryIndexEntity } from '../../categories/domain/entities/category_index_entity';
import http from "../../../plugins/http-common"
import i18n from "../../../i18n"

export const HttpCategoryRepository = {
  ...CategoryContract,
  model_index: categoryIndexEntity,

  async index(page, per_page, search, sort_by) {
    var sort = ""
    if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;

    var pp = ""
    if (per_page != null) '&per_page=' + per_page;

    const res = await http.get('categories?page=' + page + pp + '&search=' + search + sort + "&fields=id,name,description");

    for(let i = 0; i < res.data.data.length; i++) {
      res.data.data[i].attributes.actions = JSON.parse(JSON.stringify([
        {
            name: i18n.t('categories.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            link: 'categories/details/' + res.data.data[i].id,
            permission: "category.show"
        },
        {
            name: i18n.t('categories.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: 'categories/edit/' + res.data.data[i].id,
            permission: "category.update"
        },
        {
            name: i18n.t('categories.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
            permission: "category.delete"
        }
      ]));

      res.data.data[i].attributes.parameters = res.data.data[i].id;
    }

    return res;
  },
};